import { render } from "./Consultation-popup.vue?vue&type=template&id=6874dbfc&scoped=true"
import script from "./Consultation-popup.vue?vue&type=script&lang=js"
export * from "./Consultation-popup.vue?vue&type=script&lang=js"

import "./Consultation-popup.vue?vue&type=style&index=0&id=6874dbfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6874dbfc"]])

export default __exports__